import CaseCategoryChart from "@/components/charts/case-category-chart";
import CaseCourtTypeYearChart from "@/components/charts/case-court-type-year-chart";
import CasePerMediationChart from "@/components/charts/case-per-mediation-chart";
import CasePerPilotCourt from "@/components/charts/case-per-pilot-court";
import CasePerProvinceChart from "@/components/charts/case-per-province-chart";
import CasePerYearSummaryChart from "@/components/charts/case-per-year-summary-chart";
import CaseYearCategoryChart from "@/components/charts/case-year-category-chart";
import CasesPieChart from "@/components/charts/cases-pie-chart";
import CourtTypeChart from "@/components/charts/court-type-chart";
import CourtsChart from "@/components/charts/courts-chart";
import HearingsPerMonthChart from "@/components/charts/hearings-per-month-chart";
import SampleDrilldownChart from "@/components/charts/sample-drilldown-chart";
import { Tabs, TabsContent, TabsGroup, TabsList, TabsTrigger } from "@/components/core/tabs";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_backoffice/branch-statistics")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Content pageName="Statistics">
			{/*<Header title="Statistics" />*/}
			<div className="flex flex-col w-full max-w-base p-6 gap-4">
				<div className="flex flex-col w-full h-full gap-4">
					<Tabs orientation="vertical" defaultValue="case-per-year-summary">
						<TabsList>
							<TabsGroup label="Cases Per Status">
								<TabsTrigger className="text-sm" value="case-per-year-summary">
									Cases Per Year Summary
								</TabsTrigger>
								<TabsTrigger className="text-sm" value="case-per-year-per-category">
									Cases Per Year Per Category
								</TabsTrigger>
								<TabsTrigger className="text-sm" value="case-category">
									Cases Per Category
								</TabsTrigger>
							</TabsGroup>

							<TabsGroup label="Cases">
								<TabsTrigger className="text-sm" value="cases-summary">
									Cases Summary
								</TabsTrigger>
							</TabsGroup>

							<TabsGroup label="Hearings">
								<TabsTrigger className="text-sm" value="hearings-per-month">
									Hearings Per Month
								</TabsTrigger>
							</TabsGroup>
						</TabsList>

						<TabsContent value="case-per-province">
							<CasePerProvinceChart />
						</TabsContent>

						<TabsContent value="case-per-court-per-year">
							<CaseCourtTypeYearChart />
						</TabsContent>

						<TabsContent value="case-per-year-summary">
							<CasePerYearSummaryChart hasBranch={true} />
						</TabsContent>

						<TabsContent value="case-per-year-per-category">
							<CaseYearCategoryChart />
						</TabsContent>

						<TabsContent value="cases-summary">
							<CasesPieChart hasBranch={true} />
						</TabsContent>

						<TabsContent value="case-category">
							<CaseCategoryChart hasBranch={true} />
						</TabsContent>

						<TabsContent value="sample">
							<SampleDrilldownChart />
						</TabsContent>

						<TabsContent value="hearings-per-month">
							<HearingsPerMonthChart hasBranch={true} />
						</TabsContent>
					</Tabs>
				</div>
			</div>
		</Content>
	);
}
